import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { showToast } from "../helpers/Utils";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_BASE_URL || "",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error) {
    const status = result.error.status;
    if (status === 401) {
      // Dynamic import avoids circular init: dmApi → authSession → store → dmApi
      const { handleUnauthorized } = await import("../helpers/authSession");
      handleUnauthorized();
    } else if (status === 403) {
      showToast("You don't have permission.", "error");
    }
  }

  return result;
};

export const dmApi = createApi({
  reducerPath: "dmApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "getOrdersApi",
    "getPrescriptionApi",
    "VaDistributors",
    "VaSettings",
    "VaBills",
    "VaAudiologistSkus",
    "VaAudiologistBundles",
    "VaHospitalsWithOrders",
    "VaHospitals",
    "VaDistributorMetrics",
    "VaHospitalOrderVolume",
    "getRedemptionCodesApi",
    "AppVersions",
  ],
  endpoints: () => ({}),
});
